import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=a105fce0"
import script from "./Form.vue?vue&type=script&setup=true&lang=js"
export * from "./Form.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a105fce0')) {
      api.createRecord('a105fce0', component.options)
    } else {
      api.reload('a105fce0', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=a105fce0", function () {
      api.rerender('a105fce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/dialogs/Form.vue"
export default component.exports